module.exports = require("./hr-BA.d.ts");